import {
  NavigateFunction,
  NavigateOptions,
  Outlet,
  ScrollRestoration,
  To,
  useNavigate,
} from 'react-router'

let navigateFn: NavigateFunction = () => {}

export function Root() {
  // BrowserRouter doesn't let us pass a custom history object, so we have to
  // use the one that it creates. This is a bit of a hack, but it works.
  navigateFn = useNavigate()
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  )
}

export function getHistory() {
  // Fake History
  return {
    push: (to: To, options?: NavigateOptions) => navigateFn(to, options),
  }
}
